import { JointlyControlledRenderers } from './renderer';

type viewData = {
    scene_name: string,
    fov: number,
    depth_min: number,
    depth_max: number,
};

const SLICE_STEP = 3;
var viewerSlice = {start: 0, end: SLICE_STEP};

var activeRenderers: JointlyControlledRenderers[] = [];

async function initRendererTable(): Promise<void> {
    const viewerTable: HTMLElement = document.getElementById('viewer-table')!;
    const assetsPath = viewerTable.getAttribute('assets-path') || '';

    const json = await fetch(`${assetsPath}/metadata.json`).then(data => data.json());
    const modelNames: string[] = json['model_names'];
    const viewList: viewData[] = json['view_list'];

    await createRenderers(viewList.slice(viewerSlice.start, viewerSlice.end), assetsPath, modelNames);

    const nextButton: HTMLElement | null = document.getElementById('next')!;

    if (nextButton) {
        nextButton.addEventListener('click', () => {
            if (viewerSlice.end + SLICE_STEP < viewList.length) {
                viewerSlice.start += SLICE_STEP;
                viewerSlice.end += SLICE_STEP;
                createRenderers(viewList.slice(viewerSlice.start, viewerSlice.end), assetsPath, modelNames);
            }
        });
    }

    const previousButton: HTMLElement | null = document.getElementById('previous')!;

    if (previousButton) {
        previousButton.addEventListener('click', () => {
            if (viewerSlice.start > SLICE_STEP) {
                viewerSlice.start -= SLICE_STEP;
                viewerSlice.end -= SLICE_STEP;
                createRenderers(viewList.slice(viewerSlice.start, viewerSlice.end), assetsPath, modelNames);
            }
        });
    }
}

async function createRenderers(viewData: viewData[], assetsPath: string, modelNames: string[]): Promise<void> {
    const container: HTMLElement = document.getElementById('viewer-table')!;
    const showTitles = container.getAttribute('show-titles') !== 'false';

    await Promise.all(activeRenderers.map(renderer => renderer.destroy()));

    for (let child of Array.from(container.children)) {
        if (child.classList.contains('renderers')) {
            child.remove();
        }
    }

    for (let view of viewData) {
        const viewElement = document.createElement('div');
        viewElement.classList.add('renderers');
        viewElement.setAttribute('scene-name', view.scene_name);
        container.appendChild(viewElement);
        const renderers = new JointlyControlledRenderers(
            viewElement,
            assetsPath,
            modelNames,
            view.fov,
            view.depth_min,
            view.depth_max,
            showTitles,
        );
        activeRenderers.push(renderers);
    }
}

initRendererTable();